import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import SummaryApi from "../../common";
import { CgMoreO } from "react-icons/cg";
import { useNavigate } from 'react-router-dom';

const getStudentImage = (imagePath) => {
  // Remove "images/" prefix if it exists, then create the full URL
  const imagePathWithoutPrefix = imagePath.startsWith("images/")
    ? imagePath.slice(7)
    : imagePath;
  return `${SummaryApi.getStudentImage.url}${imagePathWithoutPrefix}`;
};

const AllStudents = () => {
  const [students, setStudents] = useState([]); // State to store student data
  const [loading, setLoading] = useState(true); // State to handle loading status
  const [error, setError] = useState(null); // State to handle errors
  const navigate = useNavigate(); // Hook to navigate programmatically

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        // Fetch students using SummaryApi.getAllStudents
        const response = await fetch(SummaryApi.getAllStudents.url, {
          method: SummaryApi.getAllStudents.method,
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setStudents(data.data); // Set the retrieved data into state
        setLoading(false); // Set loading to false after data is retrieved
      } catch (err) {
        setError("Error fetching data");
        setLoading(false); // Set loading to false if there's an error
      }
    };

    fetchStudentData(); // Call the async function to fetch data
  }, []); // Empty dependency array ensures this effect runs only once on mount

  if (loading) {
    return <div>Loading...</div>; // Show loading state while fetching
  }

  if (error) {
    return <div>{error}</div>; // Show error message if there's an issue
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-3">Students</h1>

      {/* Breadcrumb Navigation */}
      <nav className="text-gray-600 mb-4">
        <ol className="flex space-x-2 text-[16px]">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/allStudents" className="hover:text-[#ffa404]">
              All Students
            </Link>
          </li>
        </ol>
      </nav>

      {/* Card Container */}
      <div className="bg-white shadow-md rounded-lg p-6 mt-6 ">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          All Students Data
        </h2>

        {/* Search Bar */}
        <div className="flex flex-col sm:flex-row sm:space-x-6 justify-center sm:justify-between items-center sm:items-center mb-6 w-full">
          <input
            type="text"
            className="p-2 pl-5 pr-5 rounded bg-gray-100 mb-4 sm:mb-0 w-full sm:w-1/4"
            placeholder="Search by Name"
          />
          <input
            type="text"
            className="p-2 pl-5 pr-5 rounded bg-gray-100 mb-4 sm:mb-0 w-full sm:w-1/4"
            placeholder="Search by Roll"
          />
          <input
            type="text"
            className="p-2 pl-5 pr-5 rounded bg-gray-100 mb-4 sm:mb-0 w-full sm:w-1/4"
            placeholder="Search by Class"
          />
          <button className="pl-5 pr-5 p-2 bg-[#FFA404] text-white rounded hover:bg-green-600 text-xl w-full sm:w-1/4">
            SEARCH
          </button>
        </div>

        {/* Table */}
        <table className="table-auto w-full border border-gray-300 border-collapse">
          <thead>
            <tr className="border-b border-gray-300">
              <th className="py-2 px-4 text-left text-gray-600">Roll</th>
              <th className="py-2 px-4 text-left text-gray-600">Photo</th>
              <th className="py-2 px-4 text-left text-gray-600">Name</th>
              <th className="py-2 px-4 text-left text-gray-600">Gender</th>
              {/* <th className="py-2 px-4 text-left text-gray-600">Class</th>
              <th className="py-2 px-4 text-left text-gray-600">Section</th> */}
              <th className="py-2 px-4 text-left text-gray-600">Parents</th>
              <th className="py-2 px-4 text-left text-gray-600">Address</th>
              <th className="py-2 px-4 text-left text-gray-600">Nationality</th>
              <th className="py-2 px-4 text-left text-gray-600">
                Date of Birth
              </th>
              <th className="py-2 px-4 text-left text-gray-600">Phone</th>
              <th className="py-2 px-4 text-left text-gray-600">E-mail</th>
              <th className="py-2 px-4 text-left text-gray-600">Actions</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student) => (
              <tr key={student.student_code} className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-gray-200">
                <td className="py-2 px-4">
                  <div className="form-check flex items-center space-x-2">
                    {/* <input type="checkbox" className="form-check-input" /> */}
                    <label className="form-check-label">
                      {student.student_code}
                    </label>
                  </div>
                </td>
                <td className="py-2 px-4 text-center">
                  <img
                    src={getStudentImage(student.student_image)}
                    alt={student.student_name}
                    className="w-24 h-24 rounded-full mb-4 border border-solid border-gray-300"
                  />
                </td>
                <td className="py-2 px-4">
                  {student.first_name} {student.last_name}
                </td>
                <td className="py-2 px-4">{student.gender}</td>
                {/* <td className="py-2 px-4">{student.class}</td>
                <td className="py-2 px-4">{student.section}</td> */}
                <td className="py-2 px-4">{student.father_name}</td>
                <td className="py-2 px-4">
                {student.address}
                  {student.city}, 
                  {student.state}, 
                  {student.pincode}
                </td>
                <td className="py-2 px-4">{student.nationality}</td>
                <td className="py-2 px-4">{student.dob}</td>
                <td className="py-2 px-4">{student.parent_mobile_number}</td>
                <td className="py-2 px-4">{student.email}</td>
                <td className="py-2 px-4">
                  <div className="dropdown">
                    <button className="dropdown-toggle" aria-expanded="false">
                      <span className="flaticon-more-button-of-three-dots"></span>
                    </button>
                    <div>
                      <button
                        className="text-blue-600 font-bold text-3xl"
                        onClick={() => navigate('/studentDetails', { state: student })}
                      >
                        <CgMoreO />
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllStudents;
